module.exports = __webpack_public_path__ + "static/media/m_35.3afe89b2.png";